import { useState } from 'react';
import { Link, useMatch } from 'react-router';
import { useCurrentUser, useIsMetaReviewer } from '../../lib/session';
import { IconBoard, IconInbox, IconMoon, IconPlug, IconSun, IconUsers } from '../../ui/icons';
import { useTheme } from '../../ui/useTheme';
import { Wordmark } from '../../ui/Wordmark';
import styles from './Rail.module.css';
import { UserMenu } from './UserMenu';

/** Barra lateral de la aplicación (arriba en móvil): la bandeja y, para ADMIN, las conexiones. */
export function Rail() {
  const { theme, setPreference } = useTheme();
  const dark = theme === 'dark';
  // El sol o la luna giran solo al pulsar el botón, no cada vez que la barra se vuelve a montar al navegar.
  const [turned, setTurned] = useState(false);
  const user = useCurrentUser();
  const metaReviewer = useIsMetaReviewer();
  const inConnections = useMatch('/conexiones/*') !== null;
  const inTeam = useMatch('/equipo') !== null;
  const inBoard = useMatch('/tablero') !== null;
  return (
    <header className={styles.rail}>
      <span className={styles.wordmark}><Wordmark tone="inverse" /></span>
      <nav className={styles.nav} aria-label="Secciones">
        <Link to="/" className={styles.item} aria-current={inConnections || inTeam || inBoard ? undefined : 'page'} title="Bandeja">
          <span className={styles.icon}><IconInbox /></span>
          <span className={styles.itemLabel}>Bandeja</span>
        </Link>
        {!metaReviewer && (
          <Link to="/tablero" className={styles.item} aria-current={inBoard ? 'page' : undefined} title="Tablero">
            <span className={styles.icon}><IconBoard /></span>
            <span className={styles.itemLabel}>Tablero</span>
          </Link>
        )}
        {user.role === 'ADMIN' && (
          <Link to="/conexiones" className={styles.item} aria-current={inConnections ? 'page' : undefined} title="Conexiones">
            <span className={styles.icon}><IconPlug /></span>
            <span className={styles.itemLabel}>Conexiones</span>
          </Link>
        )}
        {user.role === 'ADMIN' && (
          <Link to="/equipo" className={styles.item} aria-current={inTeam ? 'page' : undefined} title="Equipo">
            <span className={styles.icon}><IconUsers /></span>
            <span className={styles.itemLabel}>Equipo</span>
          </Link>
        )}
      </nav>
      <div className={styles.bottom}>
        <button type="button" className={styles.themeToggle} aria-label={dark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
          title={dark ? 'Modo claro' : 'Modo oscuro'} onClick={() => { setTurned(true); setPreference(dark ? 'light' : 'dark'); }}>
          <span key={theme} className={styles.themeIcon} data-turn={turned || undefined}>{dark ? <IconSun /> : <IconMoon />}</span>
        </button>
        <UserMenu />
      </div>
    </header>
  );
}
